/*! @pentacode/ui v0.1.0 */
import { fieldOf as e } from "./table.util.js";
// src/elements/table/table-column-drag.ts
var t = 5, n = 60, r = class {
	constructor(e) {
		this.state = {
			isDragging: !1,
			draggedField: null,
			dropTargetField: null,
			dropPosition: null,
			pinZone: null,
			willPin: null
		}, this._startX = 0, this._startY = 0, this._moved = !1, this._pointerId = null, this._ghost = null, this._headerRects = /* @__PURE__ */ new Map(), this._pinnedGroupRects = {
			left: null,
			right: null
		}, this._tableRect = null, this._onPointerMove = (e) => {
			if (this._pointerId === null || e.pointerId === this._pointerId) {
				if (!this._moved) {
					let n = e.clientX - this._startX, r = e.clientY - this._startY;
					if (Math.sqrt(n * n + r * r) <= t) return;
					this._moved = !0, this.state.isDragging = !0, this._cacheHeaderRects(), this._createGhost(e.clientX, e.clientY), document.body.style.cursor = "grabbing", this.host.requestUpdate();
				}
				this._updateGhost(e.clientX, e.clientY), this._updateDropTarget(e.clientX), this._updatePinZone(e.clientX), this._updateWillPin(), this.host.requestUpdate();
			}
		}, this._onPointerUp = (e) => {
			(this._pointerId === null || e.pointerId === this._pointerId) && (this._moved && this._performDrop(), this._cleanup(), this.host.requestUpdate());
		}, this._onScroll = () => {
			this._moved && this._cacheHeaderRects();
		}, this.host = e, e.addController(this);
	}
	hostConnected() {}
	hostDisconnected() {
		this._cleanup();
	}
	handlePointerDown(e, t) {
		e.isPrimary && (e.target.closest("button, a, input, ptc-ui-dropdown, ptc-ui-table-header-menu, wa-dropdown-item, [role='button'], .resize-handle") || (e.preventDefault(), e.currentTarget.setPointerCapture(e.pointerId), this._pointerId = e.pointerId, this._startX = e.clientX, this._startY = e.clientY, this._moved = !1, this.state.draggedField = t, globalThis.addEventListener("pointermove", this._onPointerMove, { passive: !0 }), globalThis.addEventListener("pointerup", this._onPointerUp), globalThis.addEventListener("pointercancel", this._onPointerUp), globalThis.addEventListener("scroll", this._onScroll, {
			capture: !0,
			passive: !0
		})));
	}
	_cacheHeaderRects() {
		this._headerRects.clear();
		let e = this.host.renderRoot, t = e.querySelectorAll("thead th[data-field]");
		for (let e of t) {
			let t = e.dataset.field, n = e.closest(".pinned-group-left, .pinned-group-right"), r = n?.classList.contains("pinned-group-left") ? "left" : n?.classList.contains("pinned-group-right") ? "right" : null;
			this._headerRects.set(t, {
				rect: e.getBoundingClientRect(),
				pinned: r
			});
		}
		let n = e.querySelector("thead .pinned-group-left"), r = e.querySelector("thead .pinned-group-right");
		this._pinnedGroupRects = {
			left: n?.getBoundingClientRect() ?? null,
			right: r?.getBoundingClientRect() ?? null
		}, this._tableRect = this.host.getBoundingClientRect();
	}
	_createGhost(t, n) {
		let r = this.host.columnDefs.find((t) => e(t) === this.state.draggedField);
		if (!r) return;
		let i = document.createElement("div");
		i.className = "ptc-ui-table-drag-ghost", i.textContent = r.headerName, Object.assign(i.style, {
			position: "fixed",
			zIndex: "10000",
			pointerEvents: "none",
			opacity: "0.85",
			background: "var(--color-bg, white)",
			border: "1px solid var(--ptc-ui-table-border-color, #ddd)",
			borderRadius: "4px",
			padding: "0.35rem 0.65rem",
			boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
			fontWeight: "600",
			fontSize: "0.85em",
			whiteSpace: "nowrap",
			left: `${t + 12}px`,
			top: `${n - 16}px`,
			transition: "none"
		}), this.host.renderRoot.appendChild(i), this._ghost = i;
	}
	_updateGhost(e, t) {
		this._ghost && (this._ghost.style.left = `${e + 12}px`, this._ghost.style.top = `${t - 16}px`);
	}
	_updateDropTarget(e) {
		let { left: t, right: n } = this._pinnedGroupRects, r = null;
		t && e >= t.left && e <= t.right ? r = "left" : n && e >= n.left && e <= n.right && (r = "right");
		let i = null, a = null, o = Infinity;
		for (let [t, { rect: n, pinned: s }] of this._headerRects) {
			if (t === this.state.draggedField || r !== null && s !== r || r === null && s !== null) continue;
			let c = n.left + n.width / 2, l = Math.abs(e - c);
			l < o && (o = l, i = t, a = e < c ? "before" : "after");
		}
		this.state.dropTargetField = i, this.state.dropPosition = a;
	}
	_updateWillPin() {
		let { draggedField: t, dropTargetField: n, pinZone: r } = this.state;
		if (!t) {
			this.state.willPin = null;
			return;
		}
		let i = this._getSourceColumns().find((n) => e(n) === t);
		if (!i) {
			this.state.willPin = null;
			return;
		}
		let a = i.pinned ?? null, o = null;
		r ? o = r : n && (o = this._headerRects.get(n)?.pinned ?? null), this.state.willPin = o !== a && o !== null ? o : null;
	}
	_updatePinZone(e) {
		if (!this._tableRect) {
			this.state.pinZone = null;
			return;
		}
		let { left: t, right: r } = this._tableRect;
		e < t + n ? this.state.pinZone = "left" : e > r - n ? this.state.pinZone = "right" : this.state.pinZone = null;
	}
	_performDrop() {
		let { draggedField: t, pinZone: n, dropTargetField: r, dropPosition: i } = this.state;
		if (!t) return;
		let a = this._getSourceColumns(), o = a.find((n) => e(n) === t);
		if (!o) return;
		if (n && !r) {
			this._emitPinChange(o, n === (o.pinned ?? null) ? null : n);
			return;
		}
		if (!r || !i) return;
		let s = a.find((t) => e(t) === r);
		if (!s) return;
		let c = n ?? s.pinned ?? null;
		(o.pinned ?? null) !== c && this._emitPinChange(o, c);
		let l = this._getSourceColumns().filter((e) => !e.hide), u = l.findIndex((n) => e(n) === t), d = l.findIndex((t) => e(t) === r);
		if (u !== -1 && d !== -1 && (i === "after" && d++, u < d && d--, u !== d)) {
			let t = l.map((t) => e(t)), [n] = t.splice(u, 1);
			if (n === void 0) return;
			t.splice(d, 0, n), this.host.dispatchEvent(new CustomEvent("ptc-ui-table-column-reorder", {
				detail: {
					column: o,
					fromIndex: u,
					toIndex: d,
					columnOrder: t
				},
				bubbles: !0,
				composed: !0
			}));
		}
	}
	_emitPinChange(e, t) {
		let n = e.pinned ?? null;
		n !== t && this.host.dispatchEvent(new CustomEvent("ptc-ui-table-column-pin-change", {
			detail: {
				column: e,
				previousPinned: n,
				pinned: t
			},
			bubbles: !0,
			composed: !0
		}));
	}
	_getSourceColumns() {
		return this.host.getSourceColumns();
	}
	_cleanup() {
		globalThis.removeEventListener("pointermove", this._onPointerMove), globalThis.removeEventListener("pointerup", this._onPointerUp), globalThis.removeEventListener("pointercancel", this._onPointerUp), globalThis.removeEventListener("scroll", this._onScroll, { capture: !0 }), this._pointerId !== null && (this._pointerId = null), this._ghost &&= (this._ghost.remove(), null), document.body.style.cursor = "", this.state = {
			isDragging: !1,
			draggedField: null,
			dropTargetField: null,
			dropPosition: null,
			pinZone: null,
			willPin: null
		}, this._headerRects.clear(), this._pinnedGroupRects = {
			left: null,
			right: null
		}, this._tableRect = null;
	}
};
export { r as ColumnDragController };

//# sourceMappingURL=table-column-drag.js.map